import React, { useState } from 'react'
import { serbaUsahaService } from '../../services/serbaUsahaService'

function Laporan() {
  const [tab, setTab] = useState('penjualan')
  const [tglAwal, setTglAwal] = useState('')
  const [tglAkhir, setTglAkhir] = useState('')
  const [kategori, setKategori] = useState('')
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  const formatCurrency = (val) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val || 0)
  const formatDate = (d) => {
    if (!d) return '-'
    return new Date(d).toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: 'numeric' })
  }

  const handleCari = async () => {
    setLoading(true)
    try {
      const params = {}
      if (tglAwal) params.tglAwal = tglAwal
      if (tglAkhir) params.tglAkhir = tglAkhir
      if (kategori && tab === 'penjualan') params.kategori = kategori

      let res
      if (tab === 'penjualan') res = await serbaUsahaService.getLaporanPenjualan(params)
      else if (tab === 'laba') res = await serbaUsahaService.getLaporanLaba(params)
      else res = await serbaUsahaService.getLaporanPiutang()
      setData(res.data.data)
    } catch (err) { alert('Gagal mengambil laporan') }
    finally { setLoading(false) }
  }

  return (
    <div className="card">
      <div className="card-header"><h3 className="card-title">Laporan Serba Usaha</h3></div>
      <div className="card-body">
        <ul className="nav nav-tabs mb-3">
          <li className="nav-item">
            <button className={`nav-link ${tab === 'penjualan' ? 'active' : ''}`} onClick={() => { setTab('penjualan'); setData(null) }}>Penjualan</button>
          </li>
          <li className="nav-item">
            <button className={`nav-link ${tab === 'laba' ? 'active' : ''}`} onClick={() => { setTab('laba'); setData(null) }}>Laba Rugi</button>
          </li>
          <li className="nav-item">
            <button className={`nav-link ${tab === 'piutang' ? 'active' : ''}`} onClick={() => { setTab('piutang'); setData(null) }}>Piutang</button>
          </li>
        </ul>

        <div className="row mb-3">
          <div className="col-md-2">
            <input type="date" className="form-control" value={tglAwal} onChange={e => setTglAwal(e.target.value)} placeholder="Dari" />
          </div>
          <div className="col-md-2">
            <input type="date" className="form-control" value={tglAkhir} onChange={e => setTglAkhir(e.target.value)} placeholder="Sampai" />
          </div>
          {tab === 'penjualan' && (
            <div className="col-md-2">
              <select className="form-control" value={kategori} onChange={e => setKategori(e.target.value)}>
                <option value="">Semua Kategori</option>
                <option value="Sembako">Sembako</option>
                <option value="AlatTulis">Alat Tulis</option>
                <option value="Elektronik">Elektronik</option>
                <option value="Lainnya">Lainnya</option>
              </select>
            </div>
          )}
          <div className="col-md-2">
            <button className="btn btn-primary" onClick={handleCari} disabled={loading}>
              {loading ? <i className="fas fa-spinner fa-spin"></i> : 'Cari'}
            </button>
          </div>
        </div>

        {tab === 'penjualan' && data && (
          <table className="table table-bordered table-hover">
            <thead><tr>
              <th>Tgl</th><th>No. Transaksi</th><th>Jenis</th><th>Anggota</th><th>Barang</th><th>Qty</th><th>Harga</th><th>Subtotal</th>
            </tr></thead>
            <tbody>
              {data.length === 0 ? <tr><td colSpan="8" className="text-center">Tidak ada data</td></tr> :
                data.map((d, i) => (
                  <tr key={i}>
                    <td>{formatDate(d.TglTransaksi)}</td>
                    <td>{d.NoTransaksi}</td>
                    <td>{d.JenisTransaksi}</td>
                    <td>{d.NamaAnggota || '-'}</td>
                    <td>{d.NamaBarang}</td>
                    <td className="text-center">{d.Qty}</td>
                    <td className="text-right">{formatCurrency(d.HargaSatuan)}</td>
                    <td className="text-right">{formatCurrency(d.SubTotal)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}

        {tab === 'laba' && data && (
          <div className="row">
            <div className="col-md-6">
              <table className="table table-bordered">
                <thead><tr className="bg-info text-white"><th colSpan="2">Ringkasan Laba Rugi</th></tr></thead>
                <tbody>
                  <tr><td><strong>Total Pendapatan</strong></td><td className="text-right font-weight-bold text-success">{formatCurrency(data.pendapatan)}</td></tr>
                  <tr><td><strong>Total HPP</strong></td><td className="text-right font-weight-bold text-danger">{formatCurrency(data.hpp)}</td></tr>
                  <tr className="table-active"><td><strong>Laba Kotor</strong></td><td className="text-right font-weight-bold text-primary">{formatCurrency(data.labaKotor)}</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {tab === 'piutang' && data && (
          <>
            <table className="table table-bordered table-hover">
              <thead><tr>
                <th>No. Transaksi</th><th>Tgl</th><th>Anggota</th><th>No. HP</th><th>Total</th><th>Sisa Piutang</th>
              </tr></thead>
              <tbody>
                {data.piutang?.length === 0 ? <tr><td colSpan="6" className="text-center">Tidak ada piutang</td></tr> :
                  data.piutang?.map((p, i) => (
                    <tr key={i}>
                      <td>{p.NoTransaksi}</td>
                      <td>{formatDate(p.TglTransaksi)}</td>
                      <td>{p.NamaAnggota || '-'}</td>
                      <td>{p.MobileNo || '-'}</td>
                      <td className="text-right">{formatCurrency(p.TotalHarga)}</td>
                      <td className="text-right">{formatCurrency(p.SisaPembayaran)}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className="text-right font-weight-bold">
              Total Piutang: {formatCurrency(data.totalPiutang)}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
export default Laporan
